import { systemCode } from "../..";
import { getConfiguration } from '../utils/configuration';

export function getMatchStreamingProps(match) {
    let streamingMap;
    if (match.str && match.str.sys &&  match.str.sys[systemCode]) {
        streamingMap = [];
        streamingMap[match.id] = {
        		bg:match.str.bg, 
        		fid: match.str.fid,
        		isGenius : match.str.bg != null && match.str.fid != null,
        		isAvPlayer : match.str.avp,
        		isLcoPlayer : match.str.lco,
                isArena: (match.str.asid || null) != null && match.str.ar,
                isIgameMedia: (match.str.igmsid || null) != null && match.str.igm,
        		radarStreamId : match.str.bsid,
                arenaStreamId: match.str.asid,
                igameMediaStreamId: match.str.igmsid
        }
    }
    return streamingMap;
}

export function getBetgeniusStreamingProps() {
    const configuration = getConfiguration();
    const filtered =  configuration && configuration['sts']['ss'] && configuration['sts']['ss'].filter(ss => ss['ty'] === 'GENIUS');
    if (filtered && filtered.length > 0) {
        return filtered;
    } else {
        return null;
    }
}

export function getBetgeniusV3StreamingProps() {
    const configuration = getConfiguration();
    const filtered =  configuration && configuration['sts']['ss'] && configuration['sts']['ss'].filter(ss => ss['ty'] === 'GENIUS_V3');
    if (filtered && filtered.length > 0) {
        return filtered;
    } else {
        return null;
    }
}

export function getBetradarStreamingProps() {
    const configuration = getConfiguration();
    const filtered =  configuration && configuration['sts']['ss'] && configuration['sts']['ss'].filter(ss => ss['ty'] === 'AV' || ss['ty'] === 'LCO');
   
    if (filtered && filtered.length > 0) {
        return filtered;
    } else {
        return null;
    }
}

export function getArenaStreamingProps() {
    const configuration = getConfiguration();
    const filtered =  configuration && configuration['sts']['ss'] && configuration['sts']['ss'].filter(ss => ss['ty'] === 'ARENA');
    if (filtered && filtered.length > 0) {
        return filtered;
    } else {
        return null;
    }
}

export function getIgameMediaStreamingProps() {
    const configuration = getConfiguration();
    const filtered =  configuration && configuration['sts']['ss'] && configuration['sts']['ss'].filter(ss => ss['ty'] === 'IGAMEMEDIA');
    if (filtered && filtered.length > 0) {
        return filtered;
    } else {
        return null;
    }
}

export function isMatchBetgeniusStreaming(matchStreamingProps) {
    return getBetgeniusStreamingProps() && matchStreamingProps && matchStreamingProps.isGenius;
}

export function isMatchBetgeniusV3Streaming(matchStreamingProps) {
    return getBetgeniusV3StreamingProps() && matchStreamingProps && matchStreamingProps.isGenius;
}

export function isMatchBetradarStreaming(matchStreamingProps) {
    return getBetradarStreamingProps() && matchStreamingProps && (matchStreamingProps.isAvPlayer || matchStreamingProps.isLcoPlayer);
}

export function isMatchArenaStreaming(matchStreamingProps) {
    return getArenaStreamingProps() && matchStreamingProps && matchStreamingProps.isArena ;
}

export function isMatchIgameMediaStreaming(matchStreamingProps) {
    return getIgameMediaStreamingProps() && matchStreamingProps && matchStreamingProps.isIgameMedia ;
}

export function getStreamingId(matchStreamingProps) {
    if (isMatchBetgeniusStreaming(matchStreamingProps) || isMatchBetgeniusV3Streaming(matchStreamingProps)) {
        return matchStreamingProps.fid;
    }
    if (isMatchBetradarStreaming(matchStreamingProps)) {
        return matchStreamingProps.radarStreamId;
    }
    if (isMatchArenaStreaming(matchStreamingProps)) {
        return matchStreamingProps.arenaStreamId;
    }
    if (isMatchIgameMediaStreaming(matchStreamingProps)) {
        return matchStreamingProps.igameMediaStreamId;
    }
    return null;
}

export function getStreamingBalanceLimit() {
    return  getConfiguration()['lsbl'] || 0;
}
